import axios from 'axios';
import cookieCutter from 'cookie-cutter';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

// import ShareBox from '../../hotissue/box/ShareBox';

export default function PGMBoxBTNArea(props) {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const smrPgmId = props?.data?.smr_pgm_id || '';
  const talkId = props?.data?.talk_id;
  const onAir = props?.data?.onair_yn === 'Y';
  const buttonVisible = props?.data?.button_view_yn === 'Y';
  const buttonLink = props?.data?.button_link;
  const buttonNewTab = props?.data?.link_new_yn === 'Y';
  const pgmNm = props?.data?.pgm_nm;
  const pgmId = props?.data?.pgm_id;

  // 최초 구독 여부 세팅 (상위에서 내려주는 subscriptionMap 사용)
  useEffect(() => {
    if (!smrPgmId || !props.subscriptionFetched || !props.subscriptionMap) return;
    const curr = props.subscriptionMap?.[smrPgmId];
    setIsSubscribed(curr?.is_subscription === true);
  }, [smrPgmId, props.subscriptionFetched, props.subscriptionMap]);

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const pushLog = (name, extra = {}) => {
    try {
      window.__SBSLogModuleDataLayer.push({
        type: 'click',
        option: {
          clickName: name,
          clickType: 'NC',
          value1: pgmNm,
          value2: pgmId,
          value3: extra.value3 || '',
          value4: extra.value4 || '',
          value5: extra.value5 || ''
        }
      });
    } catch (_) {}
  };

  const goLogin = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `https://join.sbs.co.kr/login/login.do?returnUrl=${returnUrl}`;
  };

  const handleOpenPopup = (talk_id) => {
    pushLog('프로그램테마 큐레이션 플레이톡버튼', { value4: talk_id });
    window.open(
      `https://www.sbs.co.kr/playtalk/module.html?code=${talk_id}`,
      '타이틀명을 입력하시오',
      'top=0,left=0,width=485,height=928,status=no,menubar=no,toolbar=no,resizable=no'
    );
  };

  const handleClick_custom = (e) => {
    pushLog('프로그램테마 큐레이션 메뉴버튼', {
      value3: props.data?.button_nm,
      value4: buttonLink
    });
  };

  const toggleSubscribe = async () => {
    // 로그인 체크
    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT');
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');

    pushLog('프로그램테마 큐레이션 구독버튼');

    if (!LOGIN_JWT) {
      // 레이어 없이 즉시 로그인 이동
      goLogin();
      return;
    }
    if (!smrPgmId) {
      alert('프로그램 정보를 확인할 수 없습니다.');
      return;
    }

    if (isLoading) return;
    setIsLoading(true);

    // 낙관적 업데이트
    const prev = isSubscribed;
    setIsSubscribed(!prev);

    try {
      if (!prev) {
        // 구독
        await axios.post(
          `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${smrPgmId}`,
          null,
          {
            headers: {
              'jwt-token': LOGIN_JWT,
              platform: platformCookie
            }
          }
        );
      } else {
        // 구독취소
        await axios.delete(
          `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${smrPgmId}`,
          {
            headers: { 'jwt-token': LOGIN_JWT }
          }
        );
      }
      // 성공 시 별도 레이어 없이 UI만 유지
    } catch (err) {
      console.error(err);
      // 실패 시 롤백
      setIsSubscribed(prev);
      alert('처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="moduleBottomBtns">
        {/* 구독 버튼: 확인 레이어 없이 즉시 토글 */}
        <a
          href="#none"
          className={isSubscribed ? 'btnType-subscribe current' : 'btnType-subscribe'}
          onClick={(e) => {
            e.preventDefault();
            toggleSubscribe();
          }}
          aria-busy={isLoading ? 'true' : 'false'}
        >
          <span className="iconSvg_subscribe"><i className="hide">구독</i></span>
        </a>

        {/* 플레이톡 */}
        <a
          href="#none"
          onClick={() => handleOpenPopup(talkId)}
          className="btnType-playtalk"
          style={{ visibility: (props.data?.talk_view_yn === 'Y' ? 'visible' : 'hidden') }}
        >
          <span className="iconSvg_playtalk"></span>
          <strong className="btnType-title">플레이톡</strong>
        </a>

        {/* 라이브 / 커스텀 버튼 */}
        {onAir ? (
          <Link href="/ko/m/live">
            <a className="btnType-live">
              <span className="iconSvg_live"></span>
              <strong className="btnType-title">라이브</strong>
            </a>
          </Link>
        ) : (
          buttonVisible && (
            <Link href={buttonLink}>
              <a
                onClick={handleClick_custom}
                target={buttonNewTab ? '_blank' : undefined}
                className="btnType-roundGray"
                style={{ visibility: 'visible' }}
              >
                <strong className="btnType-title">
                  {props.data?.button_nm} {props.data?.programid}
                </strong>
              </a>
            </Link>
          )
        )}
      </div>
    </>
  );
}
